import { isValidDocumentID, isValidEmail, isValidMobile } from "../../../../../../utils/validation";
import { emptyLegalGuardianErrors } from "./repre-data-helpers";
import { ErrorObj, InsuredLegalRepre } from "./repre-data-types";

export const validateData = ({
  legalRepreData,
  countries,
}: {
  legalRepreData: InsuredLegalRepre;
  countries: any
}): { hasErrors: boolean; newErrors: ErrorObj } => {
  const newErrors: ErrorObj = { ...emptyLegalGuardianErrors };
  let hasErrors = false;

  if (legalRepreData.name.length === 0) {
    newErrors.name = "required";
    hasErrors = true;
  }

  if (legalRepreData.lastname1.length === 0) {
    newErrors.lastname1 = "required";
    hasErrors = true;
  }

  if (legalRepreData.docType.length === 0) {
    newErrors.docType = "required";
    hasErrors = true;
  }

  if (legalRepreData.docNumber.length === 0) {
    newErrors.docNumber = "required";
    hasErrors = true;
  } else if (!isValidDocumentID(legalRepreData.docNumber, legalRepreData.docType)) {
    newErrors.docNumber = "invalid-document-dni";
    hasErrors = true;
  }

  if (
    legalRepreData.docType === "PAS" &&
    legalRepreData.passportDate &&
    legalRepreData.passportDate.length === 0
  ) {
    newErrors.passportDate = "required";
    hasErrors = true;
  }

  if (legalRepreData.relationship.length === 0) {
    newErrors.relationship = "required";
    hasErrors = true;
  }

  if (!isValidEmail(legalRepreData.email)) {
    newErrors.email = "invalid-email";
    hasErrors = true;
  }

  const mobileFields = legalRepreData.mobilePhone && legalRepreData.mobilePhone.split(" ");
  const mobilePrefix = legalRepreData.mobilePhone && legalRepreData.mobilePhone.split(" ")[0];
  if (!mobileFields || mobileFields.length < 2 || !mobilePrefix || !mobileFields[1]) {
    newErrors.mobilePhone = "required";
    hasErrors = true;
  } else if (mobilePrefix === "+34" && !isValidMobile(legalRepreData.mobilePhone)) {
    newErrors.mobilePhone = "invalid-phone-number";
    hasErrors = true;
  } else {
    const isValidPrefix = countries.find(
      (country: any) => country.prefix === mobilePrefix.replace("+", "")
    );
    if (!isValidPrefix) {
      newErrors.mobilePhone = "invalid-prefix";
      hasErrors = true;
    }
  }

  return {
    hasErrors,
    newErrors,
  };
};
